import { render, staticRenderFns } from "./SelectObjekttypen.vue?vue&type=template&id=ea8508c8"
import script from "./SelectObjekttypen.vue?vue&type=script&lang=js"
export * from "./SelectObjekttypen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports